import { SVGProps } from "react";

export const CloseButton = (props: SVGProps<SVGSVGElement>) => (
  <svg height="15" width="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m9.83829238 7.5 4.67369312-4.67369312c.6391866-.63918664.6485932-1.69548241.0028916-2.34118402-.6502033-.65020332-1.6938854-.64440698-2.341184.00289165l-4.6736931 4.67369311-4.67369312-4.67369311c-.63918664-.63918665-1.69548241-.64859326-2.34118402-.00289165-.65020332.65020333-.64440698 1.6938854.00289165 2.34118402l4.67369311 4.67369312-4.67369311 4.6736931c-.63918665.6391867-.64859326 1.6954824-.00289165 2.341184.65020333.6502034 1.6938854.644407 2.34118402-.0028916l4.67369312-4.67369312 4.6736931 4.67369312c.6391867.6391866 1.6954824.6485932 2.341184.0028916.6502034-.6502033.644407-1.6938854-.0028916-2.341184z"
      fill={props.fill || "#fff"}
      fill-rule="evenodd"
    />
  </svg>
);
